var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.2667C7 10.6227 8.3327 9.29004 9.97667 9.29004H14.99C16.634 9.29004 17.9667 10.6227 17.9667 12.2667V14.7734C17.9667 16.4173 16.634 17.75 14.99 17.75H9.97667C8.3327 17.75 7 16.4173 7 14.7734V12.2667ZM13.2332 12.8934C13.2332 12.4792 12.8974 12.1434 12.4832 12.1434C12.069 12.1434 11.7332 12.4792 11.7332 12.8934V14.1467C11.7332 14.5609 12.069 14.8967 12.4832 14.8967C12.8974 14.8967 13.2332 14.5609 13.2332 14.1467V12.8934Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9899 9.76V8.50667C14.9899 7.12227 13.8676 6 12.4832 6V6C11.0988 6 9.97656 7.12227 9.97656 8.50667L9.97656 9.76",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.a01a8f04f87667314fd10266d03eaebe.svg";
export { ForwardRef as ReactComponent };